import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ModalContainer from 'app/containers/ModalContainer';
import FeedbackForm from './FeedbackForm';

/** @extends React.Component */
export default class FeedbackModal extends BcReactComponent {
  render () {
    return (
      <ModalContainer className="cp-feedback-modal" handleClose={this.props.handleClose} modalKey={this.props.modalKey}>
        <FeedbackForm {...this.props} />
      </ModalContainer>
    );
  }
}

FeedbackModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  previewActions: PropTypes.objectOf(PropTypes.func),
  previewTransactions: ImmutablePropTypes.map
};
